import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-bank",
  "use": "icon-si-glyph-bank-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-bank\" id=\"icon-si-glyph-bank\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>896</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M15,14 L15,13 L13.998,13 L13.998,12 L13,12 L13,6.032 L12.031,6.032 L12.031,12 L10,12 L10,6.032 L9,6.032 L9,12 L7,12 L7,6.032 L6,6.032 L6,12 L4,12 L4,6.032 L3.01,6.032 L3,12 L2,12 L2,13 L1,13 L1,14 L0,14 L0,15 L16,15 L16,14 L15,14 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M2.021,6 L13.979,6 L13.979,5 L14.979,5 L14.979,4 L13.969,4 L8.031,0.094 L2.031,4 L1,4 L1,5 L2.021,5 L2.021,6 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-bank.svg
// module id = f8G2
// module chunks = 62